module.exports = __webpack_public_path__ + "static/media/entity-viewer-toolbar.5e657bf5.png";